import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { I18nModule } from '@spartacus/core';
import { BehaviorSubject, Subscription, take } from 'rxjs';
import { PricingStatusReportRequest } from '../../_core/models/pricing-status.model';
import { initialStatus, loadingStatus } from '../../../../../core/models/request-status.model';
import { LocalLoaderComponent } from '../../../../../components/loader/local-loader/local-loader.component';
import { AlertComponent } from '../../../../../components/alert/alert.component';
import { Alert, ALERT_TYPE } from '../../../../../components/alert/alert.model';
import { ReportsService } from '../../_core/reports.service';

@Component({
  selector: 'pricing-status',
  standalone: true,
  imports: [CommonModule, I18nModule, LocalLoaderComponent, AlertComponent],
  templateUrl: './pricing-status.component.html',
  styleUrl: './pricing-status.component.scss',
})
export class PricingStatusComponent implements OnInit, OnDestroy {
  report$ = new BehaviorSubject<PricingStatusReportRequest>(initialStatus);
  subscription = new Subscription();

  alertDanger: Alert = {
    isActive: true,
    title: '',
    content: '',
    containerClass: 'm-t-20',
    hasCloseButton: false,
    type: ALERT_TYPE.DANGER,
  };

  constructor(private reportsService: ReportsService) {}

  ngOnInit(): void {
    this.getPricingReport();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getPricingReport() {
    this.report$.next(loadingStatus);

    this.subscription.add(
      this.reportsService
        .getPricingStatus()
        .pipe(take(1))
        .subscribe(_report => {
          const report: PricingStatusReportRequest = {
            ..._report,
          };

          if (report.hasError) {
            this.alertDanger.content = report.message!;
          }

          this.report$.next(report);
        }),
    );
  }
}
